module.exports = __webpack_public_path__ + "static/media/cum-facem-pe-scurt.0d7cd5ae.svg";